// Copied verbatim from tab-portal src/lib/name-identification (qa c50f5268), the portal mirror of
// core-api src/utils/nameIdentification. Rules only: no AI pass. Keep the three in step.
/** Legal entity suffixes — high-confidence business signals. */
export const LEGAL_SUFFIXES = [
  'L.L.C.',
  'LLC',
  'INCORPORATED',
  'INC',
  'CORPORATION',
  'CORP',
  'LTD',
  'LLP',
  'LP',
  'PLLC',
  'PC',
  'CO',
  'COMPANY',
] as const

/**
 * Organization descriptors without a legal suffix.
 *
 * Matched as whole tokens OR as a truncation prefix (client files cut names at
 * 25 chars, e.g. "BENEVOLENT HEALTHCARE FOU"). Truncation matching only fires
 * on the LAST token — see `findOrgDescriptor` — so surnames such as FOURNIER or
 * SERVIN are not swept up mid-name.
 */
export const ORG_DESCRIPTORS = [
  'FOUNDATION',
  'TRUST',
  'ASSOCIATES',
  'ASSOCIATI',
  'GROUP',
  'HOLDINGS',
  'PARTNERS',
  'SERVICES',
  'SERVICE',
  'CONSULTING',
  'BANK',
  'CHURCH',
  'RESEARCH',
  'RELOCATION',
  'HEALTHCARE',
  'FOU',
  'UNIVERSITY',
  'COLLEGE',
  'HOSPITAL',
  'CLINIC',
  'INSURANCE',
  'MORTGAGE',
  'CAPITAL',
  'INVESTMENTS',
  'MANAGEMENT',
  'ENTERPRISES',
  'SOLUTIONS',
  'SYSTEMS',
  'TECHNOLOGIES',
  'INDUSTRIES',
  'TRADING',
  'POST',
  'LOUNGE',
  'STORE',
  'SHOP',
  'CENTER',
  'CENTRE',
  'SUPPLY',
  'SUPPLIES',
  'RESTAURANT',
  'CAFE',
  'STUDIO',
  'AGENCY',
  'CONTRACTORS',
  'CONTRACTOR',
] as const

/** Person suffix tokens (generational / professional). */
export const PERSON_SUFFIXES = new Set([
  'JR',
  'SR',
  'II',
  'III',
  'IV',
  'V',
  'MD',
  'DDS',
  'PHD',
  'ESQ',
  'RN',
  'CPA',
])

/**
 * Common given names for disambiguating bare 2-token strings.
 * Not exhaustive — reduces false business on "SMITH JOHN" style rows.
 */
export const COMMON_GIVEN_NAMES = new Set([
  'MICHAEL',
  'CHARLES',
  'LINDA',
  'NAOMI',
  'MARK',
  'FRANKLIN',
  'SHELLEY',
  'CHERYL',
  'LISA',
  'MARIE',
  'DAVID',
  'MARCOS',
  'JEAN',
  'LAWRENCE',
  'MARY',
  'PAT',
  'JOHN',
  'JANE',
  'ROBERT',
  'JAMES',
  'WILLIAM',
  'RICHARD',
  'JOSEPH',
  'THOMAS',
  'CHRISTOPHER',
  'DANIEL',
  'MATTHEW',
  'ANTHONY',
  'DONALD',
  'PAUL',
  'STEVEN',
  'ANDREW',
  'KENNETH',
  'JOSHUA',
  'KEVIN',
  'BRIAN',
  'GEORGE',
  'EDWARD',
  'RONALD',
  'TIMOTHY',
  'JASON',
  'JEFFREY',
  'RYAN',
  'JACOB',
  'GARY',
  'NICHOLAS',
  'ERIC',
  'JONATHAN',
  'STEPHEN',
  'LARRY',
  'SCOTT',
  'FRANK',
  'BENJAMIN',
  'GREGORY',
  'SAMUEL',
  'RAYMOND',
  'PATRICK',
  'ALEXANDER',
  'JACK',
  'DENNIS',
  'JERRY',
  'TYLER',
  'AARON',
  'JOSE',
  'ADAM',
  'NATHAN',
  'HENRY',
  'DOUGLAS',
  'ZACHARY',
  'PETER',
  'KYLE',
  'NOAH',
  'ALAN',
  'ETHAN',
  'JEREMY',
  'WALTER',
  'CHRISTIAN',
  'KEITH',
  'ROGER',
  'TERRY',
  'AUSTIN',
  'SEAN',
  'GERALD',
  'CARL',
  'HAROLD',
  'DYLAN',
  'ARTHUR',
  'LAWRENCE',
  'JORDAN',
  'JESSE',
  'BRYAN',
  'BILLY',
  'BRUCE',
  'GABRIEL',
  'JOE',
  'LOGAN',
  'ALBERT',
  'WILLIE',
  'ALAN',
  'EUGENE',
  'RUSSELL',
  'BOBBY',
  'VICTOR',
  'MARTIN',
  'ERNEST',
  'PHILLIP',
  'TODD',
  'JESSE',
  'CRAIG',
  'STANLEY',
  'SHAWN',
  'CLARENCE',
  'SEAN',
  'PHILIP',
  'CHRIS',
  'JOHNNY',
  'EARL',
  'JIMMY',
  'ANTONIO',
  'DANNY',
  'BRYAN',
  'TONY',
  'LUIS',
  'MIKE',
  'STANLEY',
  'LEONARD',
  'NATHANIEL',
  'MANUEL',
  'RODNEY',
  'CURTIS',
  'NORMAN',
  'ALLEN',
  'MARVIN',
  'VINCENT',
  'GLENN',
  'JEFFERY',
  'TRAVIS',
  'JEFF',
  'CHAD',
  'MELVIN',
  'ALFRED',
  'KYLE',
  'FRANCIS',
  'BRADLEY',
  'JESUS',
  'HERBERT',
  'FRED',
  'RAY',
  'JOEL',
  'EDWIN',
  'DON',
  'EDDIE',
  'RICKY',
  'TROY',
  'RANDALL',
  'BARRY',
  'ALEXANDER',
  'BERNARD',
  'MARIO',
  'LEROY',
  'FRANCISCO',
  'MARCUS',
  'THEODORE',
  'CLIFFORD',
  'MIGUEL',
  'OSCAR',
  'JAY',
  'JIM',
  'TOM',
  'CALVIN',
  'ALEX',
  'JON',
  'RONNIE',
  'BILL',
  'LLOYD',
  'TOMMY',
  'LEON',
  'DEREK',
  'WARREN',
  'DARRELL',
  'JEROME',
  'FLOYD',
  'LEO',
  'ALVIN',
  'TIM',
  'WESLEY',
  'GORDON',
  'DEAN',
  'GREG',
  'JORGE',
  'DUSTIN',
  'PEDRO',
  'DERRICK',
  'DAN',
  'LEWIS',
  'ZACHARY',
  'COREY',
  'HERMAN',
  'MAURICE',
  'VERNON',
  'ROBERTO',
  'CLYDE',
  'GLEN',
  'HECTOR',
  'SHANE',
  'RICARDO',
  'SAM',
  'RICK',
  'LESTER',
  'BRENT',
  'RAMON',
  'CHARLIE',
  'TYLER',
  'GILBERT',
  'GENE',
])

/** Sub-threshold names route to AI second pass (portal/core-api endpoint). */
export const AI_CONFIDENCE_THRESHOLD = 0.93
